import { getCookie } from '../components/common/cookie'
import config from '../services/config.json'

export const PASSWORD_PATTERN = /(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[\W_]).{8,20}/
export const NAME_PATTERN = /^[A-Za-z]+\s*[A-Za-z]+$/

export const isAuthenticated = () => getCookie('padiWxId')
export const getPadiWxId = () => getCookie('padiWxId')

export const isMainlandUser = (userInfo) => userInfo?.addressDTO?.countryISOCode === 'CN'

export const isMainlandPro = (profile) => profile.teachingLocation === 'CN'

export const isTaiwanUser = () => {
  const origin = document.location.origin
  return origin === config.URL_prod_tw
}
